var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.selectedSortBy
    ? _c("rb-dummy-skeleton", {
        staticClass: "rb-sort-by --skeleton --no-selection",
      })
    : _c(
        "button",
        {
          staticClass: "rb-sort-by --no-selection",
          attrs: { type: "button" },
          on: { click: _vm.toggleSortBy, focusin: _vm.resetFocusedTileId },
        },
        [
          _c("div", { staticClass: "rb-sort-by__label" }, [
            _vm._v(_vm._s(_vm.$t("plp.filters.sort_by.label")) + ":"),
          ]),
          _vm._v(" "),
          !_vm.isMobile
            ? _c(
                "div",
                {
                  staticClass: "rb-sort-by__selected",
                  attrs: { "data-mnt-header-filter": _vm.selectedSortBy },
                },
                [_vm._v("\n    " + _vm._s(_vm.selectedSortBy) + "\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("rb-lazy-icon", {
            staticClass: "--no-selection",
            attrs: { icon: _vm.open ? "caret-big-up" : "caret-big-down" },
          }),
          _vm._v(" "),
          _vm.open
            ? _c(
                "div",
                { staticClass: "rb-sort-by__options" },
                _vm._l(_vm.sortOptions, function (option) {
                  return _c(
                    "button",
                    {
                      key: option.value,
                      staticClass: "rb-sort-by__option",
                      class: {
                        "rb-sort-by__option--selected":
                          _vm.checkActiveSelection(option),
                      },
                      attrs: { "data-mnt-header-filter": option.label },
                      on: {
                        click: function () {
                          return _vm.selectOption(option)
                        },
                      },
                    },
                    [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }